export default fieldValue => {
  return {
    valid: !fieldValue || !isNaN(fieldValue) ,
    validationText: "יש להזין מספרים בלבד"
  };
 
};
